import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab, Tabs } from "@mui/material";

import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import Voicebot from "./voicebot";
import CallListTab from "./callListTab";
import BulkCallTab from "./bulkCallTab";

export default function VoiceBotPipe() {
  const { id } = useParams();
  const [value, setValue] = useState<string>("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  useEffect(() => {}, [id]);
  let navigate = useNavigate();

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab label="Voice Bot" value="1" />
            <Tab label="Call List" value="2" />
            <Tab label="Bulk Call" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Voicebot />
        </TabPanel>
        <TabPanel value="2">
          <CallListTab />
        </TabPanel>
        <TabPanel value="3">
          <BulkCallTab />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
